import { Pipe, PipeTransform } from '@angular/core';
import { DynamicPipe } from 'src/app/shared/pipes/dynamic.pipe';
import { SelectedSourceDataPipe } from 'src/app/shared/pipes/selected-source-data.pipe';
import { SearchedProperty } from '../../new-order/interface/new-order.interface';
import { ExtendedPropertyDetail, PropertyDetail } from '../interface/property.interface';

@Pipe({
  name: 'bathroomDecimal',
  standalone: true,
})
export class BathroomDecimalPipe implements PipeTransform {
  constructor(
    private selectedSourceDataPipe: SelectedSourceDataPipe,
    private dynamicPipe: DynamicPipe
  ) {}

  /**
   *
   * @param value The property details data
   * @param forDisplay Whether the value is for display or not
   * @returns The bathrooms full & half value in decimal format
   */
  transform(
    value: PropertyDetail | SearchedProperty | null | undefined,
    dataTransform: boolean = true,
    forDisplay: boolean = true
  ): string | null {
    if (!value) return forDisplay ? '--' : null;

    const property = value as ExtendedPropertyDetail;

    // Prefer pre-aggregated summary values when present; otherwise fall back to flat/legacy fields.
    const summaryFullBath = Number(property.summary?.summary_BathroomsFullCalculated);
    const summaryHalfBath = Number(property.summary?.summary_BathroomsHalfCalculated);
    const hasSummaryBath = Number.isFinite(summaryFullBath) || Number.isFinite(summaryHalfBath);

    let fullBath: number;
    let halfBath: number;

    if (hasSummaryBath) {
      fullBath = Number.isFinite(summaryFullBath) ? summaryFullBath : 0;
      halfBath = Number.isFinite(summaryHalfBath) ? summaryHalfBath : 0;
    } else {
      fullBath =
        (this.dynamicPipe.transform(
          dataTransform
            ? this.selectedSourceDataPipe.transform(property, 'BathroomsFullCalculated')
            : value?.BathroomsFullCalculated,
          'number'
        ) as number) ?? 0;
      halfBath =
        (this.dynamicPipe.transform(
          dataTransform
            ? this.selectedSourceDataPipe.transform(property, 'BathroomsHalfCalculated')
            : value?.BathroomsHalfCalculated,
          'number'
        ) as number) ?? 0;
    }

    if (!fullBath && !halfBath) return forDisplay ? '--' : null;
    return halfBath ? `${fullBath}.${halfBath}` : `${fullBath}`;
  }
}
